import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";

function UltrasoundServices() {
  const reviews = [
    {
      text: "Great place, people, and atmosphere was awesome. The guy that brought me to the back had me laughing the whole way. They checked in on me a few times in the MRI machine to make sure I was doing ok and it made me feel more comfortable. I would recommend this place to anyone needing an MRI done.",
      name: "Jon C.",
      img: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      text: "Friendly staff and quick service. The facility was clean and the process was smooth from start to finish.",
      name: "Sarah M.",
      img: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      text: "Very professional and caring team. They made me feel at ease during my scan.",
      name: "David K.",
      img: "https://randomuser.me/api/portraits/men/65.jpg",
    },
  ];

  return (
    <>
      <Header />
      <section id="ultrasound-services" className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              Ultrasound
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get an Ultrasound at Rapid Lab Diagnostics and Experience the
                  Benefits of Advanced Imaging Technology
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  Ultrasound imaging is used to capture real-time pictures of
                  superficial structures and movement of the body’s internal
                  organs, as well as blood flowing through blood vessels.
                  Ultrasound imaging is fast, convenient preliminary imaging
                  technique used to determine what is happening inside the body
                  or if additional imaging, such as MRI or CT scan, is required
                  for further medical assessment to determine next steps in your
                  healthcare journey. At Rapid Lab Diagnostics, we utilize
                  state-of-the-art ultrasound technology to provide accurate and
                  detailed imaging for a wide range of medical conditions. Our
                  experienced technicians and radiologists are dedicated to
                  delivering high-quality care and ensuring your comfort
                  throughout the ultrasound process. Whether you need an
                  ultrasound for diagnostic purposes, monitoring, or guidance
                  during procedures, we are here to provide you with the best
                  possible service. Contact us today to learn more about our
                  ultrasound services and how we can assist you in your
                  healthcare needs.
                </p>

                <p className="text-primary-emphasis"></p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/ultasound-smile.png"
                  alt="Ultrasound"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="images/assets/ultraSound2.png"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="https://images.unsplash.com/photo-1579154204601-01588f351e67"
                    alt="lab2"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/ultraSound.jpeg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      Ultrasound is a safe and painless procedure that is used
                      to produce images of the inside of the body using sound
                      waves. Ultrasound imaging, also called ultrasound scanning
                      or sonography, involves the use of a small transducer
                      (probe) and ultrasound gel placed directly on the skin.
                      High-frequency sound waves are transmitted from the probe,
                      through the gel, and into the body. The transducer
                      collects the sounds that bounce back and a computer then
                      uses those sound waves to create an image on a
                      monitor.Ultrasound scans are used to examine internal
                      organs, tissues, and blood flow, and are especially
                      important in monitoring pregnancy. They can also guide
                      medical procedures and provide valuable diagnostic
                      information without using radiation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for Ultrasound
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className="text-primary-emphasis">
                  Ultrasound is commonly used to evaluate soft tissue structures
                  in the body, including the thyroid gland, breasts, abdominal
                  and pelvic organs, and testes. There are also specialty
                  ultrasounds for visualizing the blood flow in arteries and
                  veins
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}A doppler vascular ultrasound is a special
                        ultrasound technique that allows the physician to see
                        and evaluate blood flow through arteries and veins in
                        the abdomen, arms, legs, neck, and/or brain (in infants
                        and children) or within various body organs such as the
                        liver or kidneys.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Vascular ultrasound produces precise images and
                        measurements of many blood vessels in the body. It can
                        detect diseased vessels and identify a wide variety of
                        changing conditions, enabling the radiologist to make a
                        quick and accurate diagnosis.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you have any questions about our ultrasound services or
                  would like to schedule an appointment, please contact us at
                  Rapid Lab Diagnostics. Our friendly staff is here to assist
                  you and provide the care you need.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/imaging.png"
                  alt="rapidLabEnterance"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <div
                className="row"
                style={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "12px",
                }}
              >
                <h2 className="fw-bold text-primary-emphasis pt-4">
                  Patient Reviews
                </h2>
                <div
                  className="mx-auto my-3"
                  style={{
                    width: "60px",
                    height: "3px",
                    backgroundColor: "#FFD700",
                  }}
                />
                <p className="text-primary-emphasis mb-5">
                  Our patients say it best. Touchstone Imaging provides
                  welcoming, comforting outpatient facilities with friendly and
                  helpful staff.
                </p>

                <Carousel
                  indicators={false}
                  controls={true}
                  interval={null}
                  touch={true}
                  pause="hover"
                  className="d-flex justify-content-center "
                  style={{ minHeight: "438px" }}
                >
                  {reviews.map((review, i) => (
                    <Carousel.Item key={i}>
                      <div className="d-flex justify-content-center">
                        <div
                          className="contact-bg p-5 text-white rounded"
                          style={{
                            maxWidth: "800px",
                          }}
                        >
                          <div className="mb-3 fs-4">
                            <span style={{ color: "#FFD700" }}>★★★★★</span>
                          </div>
                          <p className="mb-4" style={{ lineHeight: "1.7" }}>
                            {review.text}
                          </p>

                          <img
                            src={review.img}
                            alt="user"
                            loading="lazy"
                            className="rounded-circle mb-2"
                            style={{
                              width: "70px",
                              height: "70px",
                              objectFit: "cover",
                            }}
                          />
                          <h6 className="fw-bold">{review.name}</h6>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/ultraS.jpg"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose accurate imaging and convenient service with Rapid
                    Lab Diagnostics
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    Rapid Lab Medical Imaging offers Ultrasound services with
                    state-of-the-art technology and a team of experienced
                    professionals. Our ultrasound imaging provides detailed and
                    accurate results for a wide range of medical conditions. We
                    are committed to delivering high-quality care in a
                    comfortable and welcoming environment. Whether you need an
                    ultrasound for diagnostic purposes, monitoring, or guidance
                    during procedures, we are here to provide you with the best
                    possible services. Contact us today to learn more about our
                    ultrasound services and how we can assist you in your
                    healthcare needs.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  Ultrasound Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an Ultrasound?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      You should wear comfortable, loose-fitting clothing for
                      your ultrasound exam. You may need to remove all clothing
                      and jewelry in the area to be examined. Depending on may
                      be asked to wear a gown during the procedure. For most
                      ultrasound exams, you are normally asked to lie down on a
                      comfortable exam table where the area to be examined is
                      exposed while the rest of the body is covered. After you
                      are positioned on the table, our certified sonographer
                      will apply a warm water-based gel to the area of the body
                      being studied. The sonographer will use a small handheld
                      device called a transducer, which is approximately the
                      size of a bar of soap to complete the exam. Then the
                      sonographer places the transducer on the body and gently
                      moves it back and forth over the area of interest until
                      the desired images are captured. There is usually no
                      discomfort during the exam when the transducer is pressed
                      against the area being examined. Once the imaging is
                      complete, the water-based gel will be wiped off your skin,
                      and any portions that are not wiped off will dry to a
                      powder. The ultrasound gel does not stain or discolor
                      clothing.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for an Ultrasound?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      The preparations for an ultrasound vary depending on the
                      body part you are having scanned. For studies involving
                      the liver, gallbladder (the gallbladder contracts when
                      food is digesting, so it is very important to follow these
                      directions so the entire gallbladder can be visualized),
                      spleen and pancreas, eat an early low-fat dinner on the
                      night before your exam and have nothing to eat or drink
                      for eight to 12 hours prior to your exam. For studies of
                      your pelvis, you will need to have a full bladder for this
                      exam. Please drink six eight oz. glasses of liquid. Finish
                      drinking this liquid one hour prior to your exam. Do Not
                      Empty your bladder before the exam. For studies of your
                      Kidneys, you may be asked to drink four to six glasses of
                      liquid one hour prior to your exam so that your bladder
                      can be visualized. For studies involving your aorta,
                      please avoid eating for 8 to 12 hours prior to your exam.
                      There is no preparation if you are having an ultrasound of
                      your breasts, extremities (arms and legs) or other body
                      parts, such as the Thyroid.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Is an Ultrasound safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Ultrasound examinations do not use ionizing radiation (as
                      used in x-rays), thus there is no radiation exposure to
                      the patient. Ultrasound is considered safe and there are
                      no known harmful effects on humans. Ultrasound has been
                      used in medical diagnosis for over 30 years and has an
                      excellent safety record. The sound waves used in
                      ultrasound are of a frequency that is not audible to the
                      human ear and do not have enough energy to cause any harm
                      to tissues or organs. However, it is important to note
                      that ultrasound should only be performed by trained
                      healthcare professionals and should be used when medically
                      necessary. If you have any concerns about the safety of
                      ultrasound, please discuss them with your healthcare
                      provider.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default UltrasoundServices;
